var global = require('../internals/global');
var hide = require('../internals/hide');
module.exports = function (key, value) {
  try {
    hide(global, key, value);
  } catch (error) {
    global[key] = value;
  }
  return value;
};